import type { SmsTemplateEntity } from './entity_types/SmsTemplate';
import { hFetch } from './hFetch';

export const listSmsTemplates = async () => {
  return (await hFetch({ url: '/api/sms_templates' })) as { records: SmsTemplateEntity[] };
};
